import React, { useState } from "react";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { SMsGatewayColumns } from "../../../data/master-settings/SMSList";
import { tableHeaderStyles } from "../../../styles/ReactSelectStyles";
import { UserListTableData } from "../../../data/users/UsersList";
import SearchBar from "../../../common-elements/search-bar/SearchBar";
import CommonDropDown from "../../common/CommonDropDown";

export const SMSData = [
  {
    sms_gateway_id: 1,
    sms_gateway_name: "Twilio",
    provider_name: "Twilio Inc.",
    type: "Transactional",
    sms_gateway_url: "https://api.twilio.com",
    sms_gateway_request_format: "JSON",
    sms_gateway_signup_url: "https://www.twilio.com/try-twilio",
    sms_gateway_recharge_url: "https://www.twilio.com/console/billing",
    status: "Default",
    Method: "Sandbox",
  },
  {
    sms_gateway_id: 2,
    sms_gateway_name: "Nexmo",
    provider_name: "Vonage (formerly Nexmo)",
    type: "Transactional",
    sms_gateway_url: "https://api.nexmo.com",
    sms_gateway_request_format: "XML",
    sms_gateway_signup_url: "https://www.nexmo.com/sign-up",
    sms_gateway_recharge_url: "https://dashboard.nexmo.com/billing",
    status: "StandBy",
    Method: "Sandbox",
  },
  {
    sms_gateway_id: 3,
    sms_gateway_name: "Plivo",
    provider_name: "Plivo Inc.",
    type: "Transactional",
    sms_gateway_url: "https://api.plivo.com",
    sms_gateway_request_format: "JSON",
    sms_gateway_signup_url: "https://www.plivo.com/sign-up",
    sms_gateway_recharge_url: "https://manage.plivo.com/billing",
    status: "StandBy",
    Method: "Live",
  },
  {
    sms_gateway_id: 4,
    sms_gateway_name: "TextLocal",
    provider_name: "Textlocal (IMIconnect)",
    type: "Promotional",
    sms_gateway_url: "https://api.textlocal.in",
    sms_gateway_request_format: "JSON",
    sms_gateway_signup_url: "https://www.textlocal.in/sign-up",
    sms_gateway_recharge_url: "https://www.textlocal.in/recharge",
    status: "StandBy",
    Method: "Live",
  },
  {
    sms_gateway_id: 5,
    sms_gateway_name: "Clickatell",
    provider_name: "Clickatell",
    type: "Promotional",
    sms_gateway_url: "https://api.clickatell.com",
    sms_gateway_request_format: "XML",
    sms_gateway_signup_url: "https://www.clickatell.com/sign-up",
    sms_gateway_recharge_url: "https://portal.clickatell.com/billing",
    status: "StandBy",
    Method: "Sandbox",
  },
];
function SMS() {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  return (
    <div>
      <Breadcrumbs mainTitle={t("SMSGateway")} parent={t("MasterSetings")} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Search bar (left) */}
                    <SearchBar
                      label={t("Search")}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder={t("SearchByLeaveName")}
                    />
                    <div className="search-dropdown">
                      <CommonDropDown color="info" />
                    </div>
                  </div>
                </div>

                <div className="list-product">
                  <div className="table-responsive">
                    <DataTable
                      data={SMSData}
                      columns={SMsGatewayColumns(t)}
                      customStyles={tableHeaderStyles}
                      striped
                      highlightOnHover
                      pagination
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SMS;
